import { SingleLayoutContainerProps } from '../single-layout-container.model';
import { EditLayoutController } from './edit.controller';

export const EditLayout = (props: SingleLayoutContainerProps): JSX.Element => {
  return <EditLayoutController {...props} />;
};
